// A reload that knows it failed resolves `false` (a table reload that fails
// never settles).
export function isTableRefreshed(result) {
  return result !== false
}
